import { useEffect, useState } from "react";

const DEFAULT_START = 17 * 60 + 34; // 00:17:34

export function useLoopingCountdown(start: number = DEFAULT_START) {
  const [seconds, setSeconds] = useState(start);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds((prev) => (prev <= 1 ? start : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [start]);

  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}
